import type { DocItem } from 'src/@types/docs';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { DocItemsStore } from './interfaces';

export type DocItemsStoreApi = ReturnType<typeof docItemsFactory>;

export const docItemsFactory = () =>
  create(
    immer<DocItemsStore>((set) => ({
      docs: [],
      isDocsLoading: false,
      docsMap: {},
      childrenMap: {},
      setDocsLoading: (loading) =>
        set((state) => {
          state.isDocsLoading = loading;
        }),

      syncDocs: (allDocs: DocItem[]) =>
        set((state) => {
          state.docs = allDocs;

          state.docsMap = allDocs.reduce<Record<string, DocItem>>(
            (acc, doc) => {
              acc[doc._id] = doc;
              return acc;
            },
            {},
          );

          const byParent: Record<string, DocItem[]> = {};
          for (const doc of allDocs) {
            if (doc.parent) {
              byParent[doc.parent] ??= [];
              byParent[doc.parent].push(doc);
            }
          }
          for (const doc of allDocs) {
            byParent[doc._id] ??= [];
          }
          state.childrenMap = byParent;
        }),
    })),
  );
